module.exports = __webpack_public_path__ + "static/farmyard3-6bf16ce1d39d249f49f40e82127166db.png";